export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  { id: 2, key: 'EVENT' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 8, key: 'TIME' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];

export const EVENT_ATTRIBUTE_TYPES = [
  { id: 21, key: 'MULTILINE_TEXT' },
  { id: 22, key: 'PERSON' },
  { id: 23, key: 'FILE' },
  { id: 24, key: 'PERSONNEL' },
];

export const ATTRIBUTE_CATEGORIES = [
  { id: 6, key: 'INFO' },
  { id: 0, key: 'AV' },
  { id: 1, key: 'CATERING' },
  { id: 2, key: 'SECURITY' },
  { id: 3, key: 'TECHNICAL' },
  { id: 4, key: 'CREW' },
  { id: 5, key: 'OTHER' },
];

export const ATTRIBUTE_CATEGORY_ICONS = {
  info: 'i-lucide-info',
  av: 'i-lucide-speaker',
  catering: 'i-lucide-utensils',
  security: 'i-lucide-shield',
  technical: 'i-lucide-wrench',
  crew: 'i-lucide-users',
  other: 'i-lucide-ellipsis',
};
